import React from 'react';
import colors from '~/data/colors';

interface EarlyBirdTicketProps {
  position: { x: string; y: string };
  priceHuf?: string;
  priceRsd?: string;
  priceEur?: string;
  link: string;
  pricepos: string;
  yPos?: number;
  text: string;
  onClick?: () => void;
}

const EarlyBirdTicket: React.FC<EarlyBirdTicketProps> = ({
  position,
  link,
  pricepos,
  text,
  priceEur,
  priceHuf,
  priceRsd,
  yPos,
  onClick,
}) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width={265} height={400} fill="none">
        <style>
          {`
            .yellow {
                font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                font-weight: 700;
                fill:${colors.orange};
                text-transform: uppercase;
            }

            .white {
                font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                font-weight: 700;
                fill:${colors.beige};
                text-transform: uppercase;
            }
            
            .bottom-ticket{
                cursor: pointer;
            }

            #hoveres{
                transition: 0.2s;
            }
            
            .ticket-button {
                pointer-events: all;
                cursor: pointer;
            }

            #hoveres:hover
            {
                transition: 0.2s;
                transform: rotateZ(-2deg) translateY(13px);
            }`}
        </style>
        <g filter="url(#a)" id="hoveres">
          {/* alsó */}
          <path
            className="bottom-ticket"
            fill={colors.orange}

            d="M245.84 266.918c-5.748 0-10.379-4.656-10.539-10.436h-12.055c-.16 5.78-4.791 10.356-10.539 10.356h-1.118c-5.749 0-10.379-4.656-10.539-10.437h-12.056c-.16 5.781-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436h-12.055c-.16 5.78-4.791 10.356-10.539 10.356h-1.118c-5.749 0-10.379-4.656-10.539-10.436h-12.056c-.16 5.78-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436H86.24c-.16 5.78-4.79 10.356-10.54 10.356h-1.117c-5.749 0-10.38-4.657-10.54-10.437H51.989c-.16 5.78-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436H17.736c-.16 5.78-4.79 10.356-10.538 10.356H6.24L6 347.358l239.601.642.399-81.082h-.16Z"
          />
          <path
            className="bottom-ticket"
            stroke={colors.beige}
            strokeMiterlimit={10}
            strokeWidth={3.966}
            d="m229 256.57-.24 81.43L23 337.43l.16-81.43"
          />
          <path
            className="bottom-ticket"
            fill={colors.beige}
            d="m215.45 286.772-178.351-.482-.1 36.601 178.353.482.098-36.601Z"
          />
          <text
            xmlSpace="preserve"
            fill={colors.orange}
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
            fontSize={17}
            fontWeight="bold"
            letterSpacing=".01em"
            style={{
              whiteSpace: 'pre',
            }}
            className="yellow bottom-ticket ticket-button"
          >
            <tspan x={position.x} y={position.y}>
              {text}
            </tspan>
          </text>
        </g>

        <g filter="url(#b)">
          <path
            fill={colors.orange}
            d="M6 228.436h.56c5.849 0 10.575 5.169 10.575 11.564H29.15c0-6.395 4.726-11.564 10.574-11.564h1.121c5.848 0 10.575 5.169 10.575 11.564h12.016c0-6.395 4.726-11.564 10.574-11.564h1.121c5.848 0 10.574 5.169 10.574 11.564h12.016c0-6.395 4.727-11.564 10.574-11.564h1.122c5.848 0 10.574 5.169 10.574 11.564h12.016c0-6.395 4.726-11.564 10.574-11.564h1.122c5.847 0 10.574 5.169 10.574 11.564h12.016c0-6.395 4.726-11.564 10.574-11.564h1.121c5.848 0 10.574 5.169 10.574 11.564h12.016c0-6.395 4.727-11.564 10.575-11.564h1.121c5.848 0 10.574 5.169 10.574 11.564h12.016c0-6.395 4.726-11.564 10.574-11.564H246V6H6v222.436Z"
          />
          <path
            stroke={colors.beige}
            strokeMiterlimit={10}
            strokeWidth={3.966}
            d="M23 240V17h206v223M23 74h208"
          />
          <text
            xmlSpace="preserve"
            fill="#fff"
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
            fontSize={24}
            fontWeight={800}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre',
            }}
            className="white"
          >
            <tspan x={pricepos} y={yPos || 146.227}>
              {priceHuf && `${priceHuf} HUF`}
            </tspan>
            <tspan x={pricepos} y={yPos || 175.227}>
              {priceRsd && `${priceRsd} RSD`}
            </tspan>
            <tspan x={pricepos} y={yPos || 204.227}>
              {priceEur && `${priceEur} EUR`}
            </tspan>
          </text>
        </g>
        <text
          xmlSpace="preserve"
          fill="#fff"
          fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
          fontSize={24}
          fontWeight="bold"
          letterSpacing=".13em"
          style={{
            whiteSpace: 'pre',
          }}
        >
          <tspan x={42.191} y={56.227} className="white">
            EARLY BIRD
          </tspan>
        </text>

        <defs>
          <filter
            id="a"
            width={260}
            height={112}
            x={0}
            y={250}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx={4} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_172_110"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_172_110"
              result="shape"
            />
          </filter>
          <filter
            id="b"
            width={260}
            height={254}
            x={0}
            y={0}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx={4} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_172_110"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_172_110"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </a>

  );
};

export default EarlyBirdTicket;
